<template lang="pug">
    v-container(style='max-width: 1185px;')
        //- Content
        v-snackbar(v-model="snackbar" color="red" top)
            | El archivo subido no es del formato adecuado .csv o agregue un archivo con formato adecuado
            template(v-slot:action="{ attrs }")
                v-btn(color="white" text="" v-bind="attrs" @click="snackbar = false")
                    | Cerrar
        //- Opciones
        v-card(v-if='!importInventory' flat outlined color="transparent")
          v-card-title.mb-6(style="color: #008e95; font-size: 2rem;").justify-center Importa y haz ajustes de inventario
          v-row(style='display:flex; justify-content:center; align-items:center; max-width: 1024px;').ma-auto
            v-col(cols="12" md="4")
              v-card(elevation='2')
                v-row
                  v-col(cols=12).text-center
                    v-icon(size='120') mdi-file-import-outline
                  v-col(cols=12).text-center
                    h2(style="color: #008e95;") Importar de un archivo
                    p.px-8.my-4 Importa nuevos productos o productos existentes a tu inventario desde un archivo csv, rapidamente y en secillos pasos o obten el formato estipulado para realizarlo.
                    v-btn(style="padding: 10px !important;" color="#008e95" @click="importInventory = true") Iniciar importanción
            v-col(cols="12" md="4")
              v-card(elevation='2')
                v-row
                  v-col(cols=12).text-center
                    img(style='height:120px;' :src="addInventory")
                  v-col(cols=12).text-center
                    h2(style="color: #008e95;") Ajuste de inventario
                    p.px-8.my-4 Haz ajustes a los productos de tu inventario, agrega cantidades a productos existentes en tu perfil de usuario y verifica el historial de ajustes de estos mismos.
                    v-btn(style="padding: 10px !important;" color="#008e95" @click="$router.push('/dashboard/transactions/add-inventory')") Hacer ajustes en los inventarios
        //- Importar inventario
        v-card(v-else color="#eee" flat)
            v-card-text.pa-0
              v-row.my-0.py-0
                v-col.d-flex.justify-end(cols="12")
                  v-btn.rounded-lg.mx-0(style="padding: 20px !important" @click="downloadCSV" color="#008e95" :loading="downloadLoading") Descargar Plantilla
              v-stepper(v-model="e6" )
                v-stepper-header.dialog-card-title(style="height: 70px !important")
                  v-row.mx-3.d-flex.align-center
                    v-col(col="9")
                      h3(v-if="e6 == 1") Selecciona el archivo
                      h3(v-else-if="e6 == 2") Escoge el destino y selecciona los campos
                      h3(v-else) Publica
                    v-col.d-flex.justify-end(cols="3")
                      dots.mr-2(:length="3" :activeDot="e6")
                v-stepper-items
                  //- Selecciona el archivo
                  v-stepper-content(step="1")
                    v-row
                      v-col(cols="12" )
                          v-card(@dragover="dragover($event)" outlined rounded @dragleave="dragleave($event)" @drop="drop($event)" :style="isDragging ? 'background-color: #ade9f1;' : '' " @click="$refs.file.click()").category-card.file-card
                            v-row.py-12
                              v-col(cols=12).text-center
                                v-icon(size='60') mdi-file-excel
                                h2(style="color: #3eb9cb;") Importa tu inventario
                                p.px-8.my-4 Arrastra aqui tu archivo con los datos para importar nuevos productos o productos existentes a tu inventario desde un archivo csv, rapidamente y en secillos pasos.
                                input#csv_file.form-control(ref="file" style='display:none;' type='file' name='csv_file', @change='loadCSV($event)' accept=".csv")
                                v-file-input(@change='loadCSV($event)' v-show="!(files === [] || !files)" v-model="files" color="primary" counter="" placeholder="Arrastra un archivo CSV o haz click aqui para cargarlo." prepend-icon="mdi-paperclip" outlined="" :show-size="1000" @click.prevent="" @click.stop="")
                                  template(v-slot:selection="{ index, text }")
                                    v-chip(v-if="index < 2" color="primary" dark="" label="" small="")
                                      | {{ text }}
                                    span.overline.grey--text.text--darken-3.mx-2(v-else-if="index === 2")
                                      | +{{ files.length - 2 }} File(s)
                    .text-center
                      v-btn(@click="importInventory = false") Cancelar
                      v-btn(color='#008e95' @click="e6 = 2" :disabled='!files').mx-2 Continuar
                  //-  Verifica los datos y escoge el destino
                  v-stepper-content.pr-0.pl-0(step="2")
                    v-col(cols="6")
                      h4.mb-1 Escoge el destino
                      v-select.rounded-xl(
                        label='Escoger sucursal destino',
                        elevation=0
                        outlined
                        :items='field.locations',
                        v-model='currentLocation',
                        item-text='full_name',
                        return-object, dense='', solo='',
                        clearable='', @input='selectShop',
                        @click:clear='clearShopSelection'
                      )
                        template(v-if='data.item' slot='selection', slot-scope='data')
                          v-avatar(size='25px')
                            img(  style='object-fit:cover; max-width: 50px' :src='getImage(data.item.pictures.imageInput1)')
                          v-flex.ml-1(style='font-size:10px;')
                              | {{ data.item.name }}
                        template(v-if='data.item' slot='item', slot-scope='data')
                          v-avatar(size='25px')
                              img(v-if='data.item' style='object-fit:cover;' :src='data.item.pictures.imageInput1')
                          v-list-tile-content
                              v-list-tile-title(v-html='data.item.name')
                    //- Lista
                    v-row.my-0.py-0(v-if="!isMobile")
                      v-col(cols="12")
                        v-data-table(:headers="headers" item-text="text" return-object :items="itemsTableCsv" hide-default-footer dense)
                          template( v-slot:item="props" )
                            tr(style="background: white;")
                              td(style="border-right: 0px;").text-xs-left
                                .datatable-cell-wrapper {{ props.item.header }}
                              td(style="border-right: 0px; border-left: 0px;").text-xs-left
                                v-row
                                  span.mr-1 {{ props.item.example1 }}
                                v-row
                                  span.mr-1 {{ props.item.example2 }}
                                v-row
                                  span.mr-1 {{ props.item.example3 }}
                              td(style="border-left: 0px;").text-xs-center
                                v-select.rounded-xl(
                                  label="Seleccione..."
                                  elevation=0
                                  outlined
                                  :items="itemsTender"
                                  item-text="text"
                                  clearable
                                  return-object dense solo
                                  @clear="validItemsTender($event, props, true)"
                                  @change="validItemsTender($event, props)"
                                  background-color="#f0f8ff"
                                  style="width: 250px; display: flex; margin: 0 auto;"
                                )
                                  template(slot='selection', slot-scope='data')
                                    p {{ data.item.text }}
                    v-col(v-else cols="12" style="padding-left: 6px !important;")
                      table.table.ps-table--responsive.ps-table--shopping-cart
                        thead
                          tr
                            th ENCABEZADO DE COLUMNA DEL ARCHIVO
                            th INFORMACIÓN DE VISTA PRELIMINAR
                            th PROPIEDAD DE TENDER
                        tbody
                          tr(v-for="(item, index) in itemsTableCsv" :key='item.header')
                            td(data-label='Encabezado de columna del archivo')
                              p {{ item.header }}
                            td(data-label='Vista preliminar' style="display: flex; flex-direction: column;")
                              v-col.mt-2
                                v-row
                                  span.mr-1 {{ item.example1 }}
                                v-row
                                  span.mr-1 {{ item.example2 }}
                                v-row
                                  span.mr-1 {{ item.example3 }}
                            td(data-label='Propiedad de tender' style="display: flex; flex-direction: column;")
                              v-select.mt-3(style="align-self: center; display: flex" :items="itemsTender"  clearable @clear="validItemsTender($event, item, true, index)" return-object item-text="text" @change="validItemsTender($event, item, false, index)" label="Seleccione..." solo)
                                template(slot='selection', slot-scope='data')
                                  p {{ data.item.text }}
                    .text-center
                      v-btn( @click="e6 = 1") Cancelar
                      v-btn(color='#008e95' :disabled="allMandatoryItemsSelected() || !currentLocation" @click="e6 = 3").mx-2 Continuar
                  //- Publicar
                  v-stepper-content(step="3")
                    v-card.elevation-0(color="grey lighten-5" height="200px" style='display:flex; flex-direction:column; justify-content:center; align-items:center;')
                      NoResults(title="Todo listo para continuar", description="Has click en el botón subir inventario para comenzar a cargar tus productos en el destino escogido")
                    .text-center
                      v-btn(@click="e6 = 2") Atras
                      v-btn(color='#008e95' style="padding: 20px !important" :disabled ="!currentLocation  || parse_csv.length === 0 || isLoading" :loading="sLoading" @click="uploadBulk").mx-2
                        | Subir inventario
</template>

<script>
  import loaders from '@/plugins/mixins/loaders'
  import shopPlaceHolder from '../../assets/icons/shop.svg'
  import firebase from 'firebase'
  import addInventory from '@/assets/icons/home/proveedores.png'
  const csv2json = require('../../plugins/cvs2json')
  export default {
    name: 'InventoryParser',
    components: {
      Tutorial: () => import('@/components/custom/Tutorial'),
      InventoryForm: () => import('@/components/custom/forms/InventoryForm'),
      dots: () => import('@/components/custom/Dots.vue'),
      NoResults: () => import('@/components/custom/NoResults'),
    },
    mixins: [loaders],
    data () {
      return {
        importInventory: false,
        files: [],
        e6: 1,
        addInventory,
        purchaseDialog: false,
        snackbar: false,
        search: '',
        currentLocation: null,
        parse_csv: [],
        shopPlaceHolder: shopPlaceHolder,
        downloadLoading: false,
        headersCsv: [],
        headers: [
          {
            sortable: false,
            text: 'ENCABEZADO DE COLUMNA DEL ARCHIVO',
            value: 'header',
          },
          {
            sortable: false,
            text: 'INFORMACIÓN DE VISTA PRELIMINAR',
            value: 'examples',
          },
          {
            sortable: false,
            text: 'PROPIEDAD DE TENDER',
            value: 'action',
          },
        ],
        itemsTableCsv: [],
        itemsTender: [
          {
            text: 'NOMBRE',
            value: 'NOMBRE',
            mandatory: true,
            disabled: false,
          },
          {
            text: 'TIPO',
            value: 'TIPO',
            mandatory: false,
            disabled: false,
          },
          {
            text: 'PRECIO DE COMPRA',
            value: 'COMPRA',
            mandatory: true,
            disabled: false,
          },
          {
            text: 'PRECIO DE VENTA',
            value: 'VENTA',
            mandatory: true,
            disabled: false,
          },
          {
            text: 'CATEGORIA',
            value: 'CATEGORIA',
            mandatory: true,
            disabled: false,
          },
          {
            text: 'UNIDADES',
            value: 'UNIDADES',
            mandatory: false,
            disabled: false,
          },
          {
            text: 'IMAGEN',
            value: 'IMAGEN',
            mandatory: false,
            disabled: false,
          },
        ],
        tempArray: [],
        isDragging: false,
      }
    },
    computed: {
      isLoading () {
        return this.$store.state.parsers.isLoading
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      categories () {
        return this.$store.getters['categories/loadItems']
      },
      products () {
        return this.$store.getters['products/loadItems']
      },
      isMobile () {
        return window.innerWidth < 1024
      },
    },

    created () {
      const vm = this
      // vm.loadProducts()
      vm.loadCategories()
    },

    methods: {
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('parsers/setCurrentShop', null).then(function () {
        })
      },
      selectShop (item) {
        const vm = this

        vm.$store.dispatch('parsers/setCurrentShop', item).then(function () {

        })
      },
      uploadBulk () {
        const vm = this
        /* if (!vm.categories || !vm.products) {
          // console.log('cargando')
          await vm.loadProducts()
          await vm.loadCategories()
        } */
        const tempcsv = []
        // se hace la relacion de cuales son los campos del csv que corresponden a los campos de tender
        const nameTenderInCsv = vm.itemsTender[0].headerCsv
        const typeTenderInCsv = vm.itemsTender[1].headerCsv
        const buyTenderInCsv = vm.itemsTender[2].headerCsv
        const saleTenderInCsv = vm.itemsTender[3].headerCsv
        const categoryTenderInCsv = vm.itemsTender[4].headerCsv
        const stockTenderInCsv = vm.itemsTender[5].headerCsv
        const imageTenderInCsv = vm.itemsTender[6].headerCsv
        vm.parse_csv.forEach(element => {
          tempcsv.push({
            NOMBRE: element[nameTenderInCsv],
            TIPO: element[typeTenderInCsv] || 'producto',
            CATEGORIA: element[categoryTenderInCsv],
            UNIDADES: element[stockTenderInCsv] || 0,
            VENTA: element[saleTenderInCsv] || 0,
            COMPRA: element[buyTenderInCsv] || 0,
            IMAGEN: element[imageTenderInCsv] || '',
          })
        })
        // console.log(tempcsv)
        vm.$store.dispatch('parsers/createBulk', tempcsv).then(function () {
          vm.e6 = 1
        })
      },
      downloadCSV () {
        const vm = this
        vm.downloadLoading = true
        const storage = firebase.storage()
        storage.ref().child('downloadables/PLANTILLA-INVENTARIO.csv').getDownloadURL().then(function (url) {
          // console.log(url)
          var a = document.createElement('a')
          a.href = url
          a.download = 'test.csv'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          a.remove()
          vm.downloadLoading = false
        }).catch(function (error) {
          console.log(error)
          vm.downloadLoading = false
          // Handle any errors
        })
      },
      loadCSV (e) {
        const vm = this
        if (e) {
          vm.files = e.target.files[0]
        }
        if (vm.files && (vm.files.type.includes('excel') || vm.files.name.includes('csv'))) {
          if (window.FileReader) {
            const reader = new FileReader()
            reader.readAsText(vm.files, 'ANSI')
            // Handle errors load

            reader.onload = function (event) {
              // console.log(event)
              const csv = event.target.result
              // console.log(csv)
              vm.parse_csv = csv2json(csv, { parseNumbers: true })
              // console.log(vm.parse_csv)
              if (vm.parse_csv.length > 0) {
                vm.headersCsv = Object.keys(vm.parse_csv[0])
                vm.headersCsv.forEach(element => {
                  if (element.length > 0) {
                    let example1 = ''
                    if (vm.parse_csv.length >= 1) {
                      example1 += vm.parse_csv[0][element] || '--'
                    }
                    let example2 = ''
                    if (vm.parse_csv.length >= 2) {
                      example2 += vm.parse_csv[1][element] || '--'
                    }
                    let example3 = ''
                    if (vm.parse_csv.length >= 3) {
                      example3 += vm.parse_csv[2][element] || '--'
                    }

                    let limitWords = 50
                    if (vm.isMobile) {
                      limitWords = 40
                    }

                    if (example1.length > limitWords) {
                      example1 = example1.substring(0, limitWords) + '...'
                    }
                    if (example2.length > limitWords) {
                      example2 = example2.substring(0, limitWords) + '...'
                    }
                    if (example3.length > limitWords) {
                      example3 = example3.substring(0, limitWords) + '...'
                    }
                    vm.itemsTableCsv.push({
                      header: element,
                      example1: example1,
                      example2: example2,
                      example3: example3,
                    })
                  }
                })
              }
            }
            reader.onerror = function (evt) {
              if (evt.target.error.name === 'NotReadableError') {
                alert('No es posible leer el archivo!')
              }
            }
          } else {
            alert('FileReader are not supported in this browser.')
          }
        } else {
          vm.snackbar = true
          document.getElementById('csv_file').value = ''
        }
      },
      getImage (url) {
        if (url === '') {
          return shopPlaceHolder
        } else {
          return url
        }
      },
      validItemsTender (event, item, deleteOption = false, indexItem = null) {
        const vm = this
        /* // console.log(event, item, item.index)
        // console.log(vm.tempArray) */
        let index
        if (vm.isMobile) {
          index = indexItem
        } else {
          index = item.index
        }
        if (vm.tempArray[index]) {
          const itemTender = vm.itemsTender.find(el => el.text === vm.tempArray[index].text)
          if (itemTender) {
            itemTender.disabled = false
            if (!deleteOption) {
              vm.tempArray[index] = event
            }
          }
        }
        if (event && !deleteOption) {
          if (vm.isMobile) {
            event.headerCsv = item.header
          } else {
            event.headerCsv = item.item.header
          }
          event.disabled = true
          vm.tempArray[index] = event
        }
      },
      allMandatoryItemsSelected () {
        const vm = this
        let disabled = false
        vm.itemsTender.forEach(element => {
          if (element.mandatory && !element.disabled) {
            disabled = true
          }
        })
        return disabled
      },
      dragover (event) {
        event.preventDefault()
        const vm = this
        vm.isDragging = true
      },
      dragleave (event) {
        const vm = this
        vm.isDragging = false
      },
      drop (event) {
        const vm = this
        event.preventDefault()
        vm.files = event.dataTransfer.files[0]
        vm.isDragging = false
        vm.loadCSV()
      },
    },
  }
</script>

<style scoped lang="scss">
    .file-card {
      display:flex;
      justify-content:center;
      align-items:center;
    }
    .panel {
        border: 2px solid #dfdfdf;
        box-shadow: rgba(0, 0, 0, 0.15) 0 1px 0 0;
        margin: 10px;
    }
    .panel.panel-sm {
        max-width: 700px;
        margin: 10px auto;
    }
    .panel-heading {
        border-bottom: 2px solid #dfdfdf;
    }
    .panel-heading h1, .panel-heading h2, .panel-heading h3, .panel-heading h4, .panel-heading h5, .panel-heading h6 {
        margin: 0;
        padding: 0;
    }
    .panel-body .checkbox-inline {
        padding: 15px 20px;
    }
    table {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    td, th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
    }

    tr:nth-child(even) {
        background-color: #dddddd;
    }

    .ps-table--shopping-cart {
      thead {
        tr {
          th {
            padding: 15px 20px;
            text-transform: uppercase;
            // color: $color-heading;
            text-align: center;
            font-weight: 600;
            background-color: #f2f2f2;
            border: none;
            &:first-child {
                text-align: left;
            }
            &:last-child {
                text-align: right;
            }
          }
        }
      }

      tbody {
        tr {
          td {
            padding: 20px 10px;
            vertical-align: middle;
            font-size: 16px;
            .form-group--number {
              max-width: 100px;
              display: inline-block;

              input {
                border-radius: 0;
              }
            }

            .ps-product--cart {
              max-width: 400px;
            }
            &:first-child {
              width: 360px;
            }
            &:last-child {
              a {
                text-align: right;
              }
            }
          }
        }
      }
      @media screen and (min-width: 768px) {
        tbody {
          tr {
            td {
              text-align: center;
              &:last-child {
                text-align: right;

                a {
                  font-size: 20px;
                }
              }
            }
          }
        }
      }
    }

    .ps-table--responsive {
      p {
        margin-bottom: 0;
      }

      @media (max-width: 767px) {
        border: none;
        thead {
          display: none;
        }

        tbody {
          display: block;

          tr {
            display: block;
            border: 1px solid #ddd;

            td[data-label] {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              border: none;
              border-top: 1px solid #ddd;
              > * {
                flex-basis: 100%;
              }
              &:before {
                display: block;
                content: attr(data-label) ':';
                margin-right: 10px;
                font-weight: 600;
                flex-basis: 100%;
                max-width: 30%;
              }

              &:first-child {
                border-top: none;
              }

              &.ps-table__item {
              }
            }

            &:nth-child(even) {
              background-color: #f9f9f9;
            }
          }
        }
      }
    }
</style>
<style lang="scss">
  .v-data-table-header {
    background: aliceblue;
  }
</style>
